<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m15.775 14.651-2.966-2.944a7.205 7.205 0 0 0-.811-9.869 7.192 7.192 0 0 0-9.89.271 7.204 7.204 0 0 0 4.498 12.27 7.192 7.192 0 0 0 5.092-1.56l2.942 2.944a.8.8 0 0 0 1.135 0 .8.8 0 0 0 0-1.112ZM7.212 12.82a5.594 5.594 0 0 1-5.17-3.458A5.605 5.605 0 0 1 6.12 1.725a5.593 5.593 0 0 1 5.745 2.381 5.604 5.604 0 0 1-.696 7.072 5.595 5.595 0 0 1-3.958 1.64Z"
      fill="currentColor"
    />
  </svg>
</template>
